import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import debug from 'debug';
import { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { AgentResponseEvent } from '@/components/Message/AgentResponseEvent';
import { BrainResponseEvent } from '@/components/Message/BrainResponseEvent/BrainResponseEvent';
import { useController } from '@/hooks/useController';
import { useSessionOverview } from '@/hooks/useSessionOverview';
import { showResetSelector, themeSelector } from '@/state/config';
import { chatEventsState, isMobileSelector } from '@/state/session';
import { Attachments } from './Attachment';
import { DeliverInfo } from './DeliverInfo';
import styles from './ChatEvent.module.scss';
const log = debug('moveo:chat-event');
export const ChatEvent = memo(({ event }) => {
    const chatEvents = useRecoilValue(chatEventsState);
    const { startSessionOverview } = useSessionOverview();
    const { notifyMemberLeave } = useController();
    const { t } = useTranslation();
    const theme = useRecoilValue(themeSelector);
    const isMobile = useRecoilValue(isMobileSelector);
    const showReset = useRecoilValue(showResetSelector);
    useEffect(() => {
        if (event.event_type === 'member_leave') {
            notifyMemberLeave();
            const isFirstMemberLeave = chatEvents.filter((e) => e.event_type === 'member_leave').length === 1;
            if (isFirstMemberLeave) {
                startSessionOverview();
            }
        }
    }, [
        event.event_id,
        event.event_type,
        chatEvents,
        notifyMemberLeave,
        startSessionOverview,
    ]);
    if (event.event_type === 'user_message') {
        return (_jsxs("li", { className: cn(styles.container, styles[theme], {
                [styles.isMobile]: isMobile && !showReset,
            }), children: [_jsx("div", { className: styles.userMessage, children: event.text }), event.attachments &&
                    event.attachments.length > 0 &&
                    event.attachments.map((a) => (_jsx(Attachments, { id: a.id, filename: a.filename, title: a.title, url: a.url, type: a.type, hasText: !!event.text }, a.id))), _jsx(DeliverInfo, { chatEvent: event })] }));
    }
    else if (event.event_type === 'agent_message') {
        return _jsx(AgentResponseEvent, { event: event });
    }
    else if (event.event_type === 'member_join') {
        return (_jsx("div", { className: cn(styles.swimmLineWithText, styles[theme]), children: _jsx("div", { children: t('events.member_join', { 0: t(event.author_name) }) }) }));
    }
    else if (event.event_type === 'member_leave') {
        return (_jsx("div", { className: cn(styles.swimmLineWithText, styles[theme]), children: _jsx("div", { children: t('events.member_leave', { 0: t(event.author_name) }) }) }));
    }
    else if (event.event_type === 'brain_message') {
        return _jsx(BrainResponseEvent, { event: event });
    }
    else {
        log('Ignoring event: %O', event);
    }
    return null;
});
ChatEvent.displayName = 'ChatEvent';
